import { DownloadIcon } from "@chakra-ui/icons";
import { Button, Icon } from "@chakra-ui/react";
import { GQLRemoteDataView } from "src/components/Layout/RemoteDataView";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { useOrganization } from "src/hooks/useOrganization";
import { useRemoteDataQuery } from "src/hooks/useRemoteDataQuery";
import { csvExport } from "src/services/dataTransfer";
import * as GQL from "src/types/graphql";
import { GET_ALL_SCHOOLS } from "./graphql/queries";

export const ExportSchoolsButton = () => {
  const organization = useOrganization();
  const toast = useAvelaToast();

  const { remoteData } = useRemoteDataQuery<
    GQL.GetAllSchools,
    GQL.GetAllSchoolsVariables
  >(GET_ALL_SCHOOLS, {
    variables: {
      organization_id: organization.map((o) => o.id).withDefault(""),
    },
    skip: !organization.hasData(),
    notifyOnNetworkStatusChange: true,
  });

  const handleOnExportClick = (data: GQL.GetAllSchools) => () => {
    const loadingToastId = toast({
      title: "Export in progress",
      description: "Download will start shortly",
      status: "loading",
    });
    try {
      const records = data.school.map(({ __typename, ...rest }) => rest);
      csvExport(records, "schools.csv");
      toast.close(loadingToastId);
      toast({ title: "Schools exported", status: "success" });
    } catch (e) {
      toast.close(loadingToastId);
      toast.error({
        title: "Something went wrong!",
        description: "Check your network and try again",
      });
      console.error(e);
    }
  };

  return (
    <GQLRemoteDataView remoteData={remoteData}>
      {(data) => (
        <Button
          variant="outline"
          size="xl"
          leftIcon={<Icon as={DownloadIcon} />}
          onClick={handleOnExportClick(data)}
        >
          Export schools
        </Button>
      )}
    </GQLRemoteDataView>
  );
};
